module.exports = __webpack_public_path__ + "img/developer.49a53b91.png";